/**
 * 全平台统一时间格式化工具 — 中国时区 (UTC+8)
 */
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

/** 将 ISO/UTC 时间字符串格式化为中国时区 (UTC+8) */
export function formatCN(
  value: string | Date | null | undefined,
  fmt = 'YYYY-MM-DD HH:mm:ss',
): string {
  if (!value) return '-';
  return dayjs.utc(value).utcOffset(8).format(fmt);
}

export default formatCN;
